import classNames from 'classnames';
import Link from 'next/link';
import { ReactNode } from 'react';

import ArrowUpRightIcon from 'components/icons/ArrowUpRightIcon';
import styles from './UILink.module.scss';

interface UILinkProps {
  textType: 'body' | 'subhead';
  size: 'small' | 'medium' | 'large';
  label: string;
  href?: string;
  onClick?: () => void;
  external?: boolean;
  icon?: ReactNode;
  className?: string;
}

const UILink = ({
  textType,
  size,
  label,
  href,
  onClick,
  external = false,
  icon,
  className: customClassName,
}: UILinkProps) => {
  const className = classNames(
    styles.link,
    styles[textType],
    styles[size],
    customClassName
  );
  const content = (
    <>
      {label}
      {icon && <span className={styles.icon}>{icon}</span>}
      {external && (
        <>
          <ArrowUpRightIcon />
          <span className="visually-hidden">(opens in a new tab)</span>
        </>
      )}
    </>
  );

  if (!href) {
    return (
      <button type="button" className={className} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <Link
      href={href}
      className={className}
      onClick={onClick}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {content}
    </Link>
  );
};

export default UILink;
